import React, { Component } from "react";
import { interval, from } from "rxjs";
import { map, switchMap, filter, take } from "rxjs/operators";

import * as overrideStages from "../model/lighting-overrides/overrideStageKeys";
import mapOverrideStage from "../model/lighting-overrides/mapOverrideStage";
import overrideTerminalStages from "../model/lighting-overrides/overrideTerminalStages";
import apiProxy from "../api/apiProxy.js";
import ToastContext from "./toastContext";

const OverrideToastContext = React.createContext();

export class OverrideToastProvider extends Component {
  static contextType = ToastContext;

  state = { toasts: [] };

  count = 0;

  overridesToMonitor = [];

  monitorOverrideStage = (overrideId, overrideName) => {
    // Don't set up a new monitor for an override which is already being monitored
    if (this.overridesToMonitor.includes(overrideId)) {
      return;
    }

    this.overridesToMonitor.push(overrideId);

    interval(30000)
      .pipe(
        switchMap(() => from(apiProxy.override.getOverrideStage(overrideId))),
        map(result => mapOverrideStage(result)),
        filter(mappedResult => overrideTerminalStages.includes(mappedResult)),
        take(1)
      )
      .subscribe(result => {
        this.overridesToMonitor = this.overridesToMonitor.filter(
          o => o !== overrideId
        );
        this.addOverrideToast(result, overrideName);
      });
  };

  addOverrideToast = (overrideStage, overrideName) => {
    switch (overrideStage) {
      case overrideStages.COMPLETED:
        this.context.add(
          "success",
          "Override sent to store",
          `${overrideName} has been successfully sent to the store.`
        );
        break;
      case overrideStages.DISCARDED:
        this.context.add(
          "success",
          "Override discarded",
          `${overrideName} has been discarded from the store.`
        );
        break;
      case overrideStages.FAILED:
        this.context.add(
          "danger",
          "Override failed",
          `${overrideName} failed to reach the store.`
        );
        break;
      case overrideStages.DISCARD_FAILED:
        this.context.add(
          "danger",
          "Override discard failed",
          `${overrideName} failed to discard from the store.`
        );
        break;
      default:
        break;
    }
  };

  render() {
    const overrideContext = {
      add: this.context.add,
      remove: this.context.remove,
      monitorOverrideStage: this.monitorOverrideStage
    };

    return (
      <OverrideToastContext.Provider value={overrideContext}>
        {this.props.children}
      </OverrideToastContext.Provider>
    );
  }
}

export default OverrideToastContext;
